import { createCategoriesItemOffersAtom } from "../create-categories-item-offers-atom";
import indoorCategoriesAtom from "./categories";
import indoorItemOffersAtom from "./item-offers";

/** Category id → sorted item offers for the INDOOR (QR) menu. */
const indoorCategoriesItemOffersAtom = createCategoriesItemOffersAtom(
  indoorCategoriesAtom,
  indoorItemOffersAtom,
);

export default indoorCategoriesItemOffersAtom;
